export const useProductApi = (query: QueryProductApi) => useApi<Product[]>('/products', { query })
export const useProductDetailApi = (
  productSlug: string,
  query?: Record<string, string>,
) => useApi<Product>(`/product/${productSlug}`, {
  query,
})
export const useProductDetailPreviewApi = (
  productSlug: string,
  query?: Record<string, string>,
) => useApi<Product>(`/product-preview/${productSlug}`, {
  query,
})

export const useRelatedProductApi = (
  productSlug: string,
  query?: Record<string, string>,
) => useApi<Product[]>(`/products/${productSlug}/relate`, {
  query,
})
